import React, { Component, cloneElement } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

class OverflowWrapper extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showOverflow: false,
    };
    this.childRef = React.createRef();

    this.getClassNames = this.getClassNames.bind(this);
    this.setOverflow = this.setOverflow.bind(this);
  }

  componentDidMount() {
    this.setOverflow();
  }

  componentDidUpdate() {
    this.setOverflow();
  }

  setOverflow() {
    const {
      childRef: { current },
      state: { showOverflow: old },
    } = this;
    if (current) {
      const showOverflow = current.scrollHeight > current.clientHeight
        || current.scrollWidth > current.clientWidth;
      if (showOverflow !== old) {
        this.setState({ showOverflow });
      }
    }
  }

  getClassNames() {
    const { showOverflow } = this.state;
    return classnames({
      OverflowWrapper: true,
      overflowing: showOverflow,
    });
  }

  render() {
    const {
      props: { children: child, overflow },
      state: { showOverflow },
      getClassNames,
    } = this;
    return (
      <div className={getClassNames()}>
        {cloneElement(child, {
          ref: this.childRef,
        })}
        {showOverflow && overflow}
      </div>
    );
  }
}

OverflowWrapper.propTypes = {
  children: PropTypes.element,
  overflow: PropTypes.node,
};

OverflowWrapper.defaultProps = {
  children: null,
  overflow: null,
};

export default OverflowWrapper;
